import { FC, ReactNode } from 'react';
import { Toggletip, ToggletipButton, ToggletipContent } from '@carbon/react';
import { Information } from '@carbon/react/icons';
import style from './unit-builder-modal.module.scss';

interface UnitBuilderPaneHeaderProps {
  title: string;
  /** Instruction copy behind the (i) toggletip. */
  info?: ReactNode;
  /** Right-aligned content, e.g. the boundary's acreage. */
  trailing?: ReactNode;
}

/**
 * A pane's title strip.
 *
 * Both panes carry the same two strips of chrome — a title row then a controls
 * row — so their canvases start on the same line. The mock pins both to fixed
 * heights (40px / 44px) for exactly that reason.
 *
 * @param {UnitBuilderPaneHeaderProps} props - Title, optional info copy and trailing content.
 * @return {JSX.Element} The title strip.
 */
export const UnitBuilderPaneHeader: FC<UnitBuilderPaneHeaderProps> = ({
  title,
  info,
  trailing,
}) => (
  <div className={style.paneHeader}>
    <span className={style.paneTitle}>{title}</span>
    {info && (
      <Toggletip align="bottom-left">
        <ToggletipButton label={`About ${title}`}>
          <Information size={16} />
        </ToggletipButton>
        <ToggletipContent>{info}</ToggletipContent>
      </Toggletip>
    )}
    {trailing && <span className={style.paneTrailing}>{trailing}</span>}
  </div>
);
